import React from 'react'

class DataTitle extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: ''
        }
    }

    componentDidMount() {
        this.setState({
            title: this.props.title
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.title != nextProps.title) {
            this.setState({
                title: nextProps.title
            })
        }
    }

    render() {
        return (
            <p className={`dataTitle ${this.props.className ? this.props.className : ''}`}>
                {
                    this.state.title
                }
            </p>
        )
    }
}

export default DataTitle